export function removeEmptyParagraph(richText: string | null | undefined): string | undefined | null {
  if (!richText) {
    return richText;
  }
  const emptyParagraphRegex = /^<p>(?:\s|&nbsp;)*<\/p>\s*$/; // matches <p></p> or <p> </p> or <p>&nbsp;</p> and end of the string
  return richText.replace(emptyParagraphRegex, '');
}
